<template>
  <div class="subpartContainer mb-1">
    <div class="paymentSubtitle">Card Information</div>
    <StripeCardInfo @triggerLoading="triggerBtnLoading" :isHSACard="this.isHSACard"/>
  </div>
  <div class="subpartContainer mb-1">
    <div class="paymentSubtitle">Billing Information</div>
    <BillingInfo :showAllBillingInfo="false" />
  </div>
  <!-- <div class="subpartContainer mb-1">
    <div class="paymentSubtitle">Contact Information</div>
    <ContactInfo />
  </div> -->
  <div class="subpartContainer">
    <el-button
      class="submitButton"
      id="submitStripePaymentButton"
      :loading="is_submitting_payment"
      :disabled="is_submitting_payment"
    >
      {{ is_submitting_payment ? "Processing..." : "Complete Payment" }}
      {{ is_submitting_payment ? "" : formatPrice(amountToPay) }}</el-button
    >
  </div>
  <div class="consentMessageContainer">
    <div class="consentMessage">
      By clicking Complete Payment above, you agree for your card provided here
      to be charged the complete amount listed to purchase testing according to
      <a
        href="https://vibrant-wellness.com/terms-of-use"
        target="_blank"
        >Terms of Service</a
      >
      and
      <a
        href="https://vibrant-wellness.com/testing-policy"
        target="_blank"
        >Testing Policies</a
      >
      from Vibrant America and
      <a href="https://vibrant-wellness.com/terms-of-use" target="_blank"
        >Terms of Service</a
      >
      from Vibrant Wellness.
    </div>
  </div>
</template>

<script>
import BillingInfo from "@/components/payment/BillingInfo.vue";
// import ContactInfo from "@/components/payment/ContactInfo.vue";
import StripeCardInfo from "@/components/payment/StripeCardInfo.vue";
import { usePaymentStore } from "@/stores/PaymentStore.ts";
import { mapState, mapActions } from "pinia";
export default {
  name: "HsaCardPayContainer",
  props: {
    isHSACard: {
      type: Boolean,
    },
  },
  components: {
    BillingInfo,
    StripeCardInfo,
  },
  data() {
    return {
      paymentMethod: "",
      loadingPayment: false,
      // amountToPay: null,
    };
  },
  created() {
    this.setCheckEmptyFields(false);
    // VIB-1764: never land on the payment form with a stuck-disabled Pay button
    this.setIsSubmittingPayment(false);
  },
  computed: {
    ...mapState(()=>usePaymentStore(), [
      'amount_to_pay',
      "billingInfo",
      'is_family_order',
      'is_submitting_payment',
    ]),
    formatPrice() {
      return (price) => {
        return Number(price).toLocaleString("en-US", {
          style: "currency",
          currency: (this.billingInfo?.currency || 'USD').toUpperCase(),
        }).replace('CHF','₣');
      };
    },
    amountToPay(){
      return this.amount_to_pay
        ? parseFloat(
            (Number(this.amount_to_pay) / 100).toFixed(2)
          )
        : (this.is_family_order ? Number(this.billingInfo?.family_orders?.patient_total ?? 0) : Number(this.billingInfo?.patient_bill?.total ?? 0));
    },
  },
  methods: {
    ...mapActions(()=>usePaymentStore(), [
      "payByCard",
      "setCheckEmptyFields",
      "saveBillingInfo",
      "setIsSubmittingPayment",
    ]),
    triggerBtnLoading(val) {
      this.loadingPayment = val;
      // VIB-1764: keep the Pay button disabled/processing state in sync
      this.setIsSubmittingPayment(val);
    },
  },
};
</script>

<style scoped>
.consentMessageContainer {
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
}

a {
  color: #20a8c3;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.consentMessage {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.45px;
  text-align: left;
}

@media only screen and (max-width: 767px) {
  .consentMessage {
    font-size: 12px;
  }
}
</style>
